import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ForgeHeaderModule = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "portal-forge-ui-header" */ './portal-header')),
    LoadingSkeleton: () => null,
});
